import { Injectable } from '@angular/core';

@Injectable()
export class ExportTable {
    constructor() { }

    exportToCSV(rows, columnsToInclude: string[], columnsCSV: string[], title: string): void {
        if (!rows || rows.length === 0) {
            console.error('No hay datos para exportar.');
            return;
        }

        const csvData = this.convertToCSV(rows, columnsToInclude, columnsCSV);
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', title);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    private convertToCSV(data: any[], columnsToInclude: string[], columnsCSV: string[]): string {

        let separator = ',';

        const headersCSV = columnsCSV.map(header => `"${header}"`).join(separator);

        const rows = data.map(row => {
            return columnsToInclude
                .map(column => {
                    const value = row[column];
                    if (value === null || value === undefined) {
                        return '""';
                    }
                    if (value === true) {
                        return '"Yes"';
                    }
                    if (value === false) {
                        return '"No"';
                    }
                    if (typeof value === 'string') {
                        return `"${value.replace(/"/g, '""')}"`;
                    }
                    return `"${value}"`;
                })
                .join(separator);
        });

        return `${headersCSV}\n${rows.join('\n')}`;
    }
}


// WEBPACK FOOTER //
// ./src/app/ExportTable.service.ts